import { Component } from '@angular/core';
import { ConfigUserDataResult, OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { Observable, lastValueFrom, of } from 'rxjs';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.css']
})
export class UserDataComponent{

  domain= window["openiddictsettings"]["authority"];
  userData$: UserDataResult;

  goToLink(url: string){
    window.open(url, "_blank");
}
refreshUserInfo(){

}


  ngOnInit() {

    this.oidcSecurityService.userData$.subscribe(val=> this.userData$=val);


  }

  constructor(private oidcSecurityService: OidcSecurityService){


  }


}
